import React from "react";
import { Formik } from "formik";
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";

import { useAxios } from "../../../hooks";
import FormDisplay from "./FormDisplay";
import {
  objectFromFormData,
  validationSchema,
} from "./customFieldsDetailsObject";
import {
  ButtonFooter,
  Paper,
  ComponentHeader,
  PageHeader,
} from "../../../components";
import DropDownDialog from "../preview fields/dropdown dialog components/DropdownDialog";
import TextFieldDialog from "../preview fields/textfield dialog components/TextFieldDialog";
import DateTestDialog from "../preview fields/date dialog components/DateTestDialog";
import RangeDialog from "../preview fields/range dialog components/RangeDialog";
import FileDialog from "../preview fields/file dialog components/FileDialog";
import { alert } from "../../../redux/slices/alertSlice";
import EditButtons from "../../../components/EditButtons";
import { useNavigate } from "react-router-dom";
import pages from "../../../constants/pages";

export default function Form({
  groups,
  formData,
  controlTypes,
  setControlTypes,
  editState,
  setEditState,
  PlatformTenantList,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={(formData, { setSubmitting }) => {
        axios({
          url: "/custom-field",
          method: "POST",
          data: objectFromFormData(formData),
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            if (formData.ID) {
              setEditState(false);
            }
            navigate(
              pages.customFieldsDetailsPage.route + response.data.field_id
            );
            dispatch(
              alert({
                type: "success",
                message: "Custom field created successfully",
              })
            );
          }
          setSubmitting(false);
        });
      }}
    >
      {(formikProps) => (
        <Grid container spacing={2}>
          <Grid size={12}>
            <PageHeader
              pageName="Custom Audience Field"
              pageHeader="Create your own audience attribute field"
              buttons={[
                <EditButtons
                  formikProps={formikProps}
                  editState={editState}
                  setEditState={setEditState}
                />,
              ]}
            />
          </Grid>

          <Grid size={9}>
            <FormDisplay
              groups={groups}
              formikProps={formikProps}
              controlTypes={controlTypes}
              setControlTypes={setControlTypes}
              editState={editState}
              PlatformTenantList={PlatformTenantList}
            />
          </Grid>

          <Grid size={3} style={{ display: "flex" }}>
            <Paper style={{ flexGrow: "1" }}>
              <Grid size={12}>
                <ComponentHeader
                  title={"Component Preview"}
                  subtitle={
                    formikProps.values.controlID
                      ? "The component will look like this when rendered on leads page."
                      : "Please select a component to se the preview."
                  }
                />
              </Grid>

              {parseInt(formikProps.values.controlID) === 5 && (
                <FileDialog formikProps={formikProps} />
              )}

              {parseInt(formikProps.values.controlID) === 1 && (
                <RangeDialog formikProps={formikProps} />
              )}

              {parseInt(formikProps.values.controlID) === 2 && (
                <DropDownDialog formikProps={formikProps} />
              )}

              {parseInt(formikProps.values.controlID) === 3 && (
                <TextFieldDialog formikProps={formikProps} />
              )}

              {parseInt(formikProps.values.controlID) === 4 && (
                <DateTestDialog formikProps={formikProps} />
              )}
            </Paper>
          </Grid>

          <Grid size={12}>
            <ButtonFooter
              ID={formikProps.values.ID}
              formikProps={formikProps}
              editState={editState}
              setEditState={setEditState}
            />
          </Grid>
        </Grid>
      )}
    </Formik>
  );
}
